<script>
import Endpoints from '../../../components/common/Endpoints'
import Common from '../../../components/common/Common'
import Request from '../../../components/common/Request'

let type = 'TRUCK_TRAILER'

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN'
    if (geo.geometry.lat) {
        addressObj.lat = geo.geometry.lat
    } else return null
    if (geo.geometry.lng) {
        addressObj.lng = geo.geometry.lng
    } else return null

    return addressObj
}

export default {
    init: async payload => {
        payload.domain = Endpoints.domain

        const el = document.body
        el.removeAttribute('class')
        $('.modal').modal('hide')

        let resultTags = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.helpers.listGasStationTags}`)
        payload.tags = resultTags.data.results
    },
    methods: {
        save: function () {
            $('#spinner').modal('toggle')
            this.errors = []
            this.messageIdToast = null

            const data = JSON.parse(JSON.stringify(this.data))

            data.document = data.document.replace('.', '').replace('.', '').replace('/', '').replace('-', '')

            const fuel = data.fuels

            if (fuel.gnv) {
                fuel.gnv = fuel.gnv.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.gas) {
                fuel.gas = fuel.gas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.premmiumGas) {
                fuel.premmiumGas = fuel.premmiumGas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.additiveGas) {
                fuel.additiveGas = fuel.additiveGas.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.ethanol) {
                fuel.ethanol = fuel.ethanol.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.premmiumEthanol) {
                fuel.premmiumEthanol = fuel.premmiumEthanol.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.diesel) {
                fuel.diesel = fuel.diesel.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.dieselS10) {
                fuel.dieselS10 = fuel.dieselS10.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.dieselS500) {
                fuel.dieselS500 = fuel.dieselS500.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }
            if (fuel.electricity) {
                fuel.electricity = fuel.electricity.toString().split('.').join('').split(',').join('.').split('R$ ').join('')
            }

            data.fuels = fuel

            if (data.mainCompany) {
                data.mainCompany = data.mainCompany.replace('.', '').replace('.', '').replace('/', '').replace('-', '')
            }

            Request.do(
                this,
                data._id ? 'PUT' : 'POST',
                Request.getDefaultHeader(this),
                data,
                `${Endpoints.companies.companyFormData}${data._id ? data.document : ''}`,
                response => {
                    $('#spinner').modal('toggle')
                    //SUCCESS CALLBACK
                    if (data._id) {
                        this.flashMessage.info(this.configMessage(this.$t('string.msg.register.title.alter'), this.$t('string.msg.gas.station.updated.message.success'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.gas.station.updated.message.success')),
                            destroyed: this.clearText(),
                        })
                    } else {
                        this.flashMessage.info(this.configMessage(this.$t('string.msg.register.title.success'), this.$t('string.msg.company.register.message.alter'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.company.register.message.alter')),
                            destroyed: this.clearText(),
                        })
                    }

                    this.data.logoURL = response.result.logoURL
                    this.data._id = response.result._id
                    this.valuekey += 1
                },
                error => {
                    //ERROR CALLBACK

                    $('#spinner').modal('toggle')
                    let res = error.response

                    if (res && res.data.status) {
                        this.titleToast = this.$t('string.msg.warning');
                        this.messageToast = this.$t(res.data.messageId);
                        if (res.data.messageId === 'response.msg.error.empty.fields') {
                            let fields = ''
                            res.data.errors.forEach(function (value) {
                                fields += this.$t(value.id) + ';<br/>'
                            })
                            this.titleToast = this.$t(res.data.messageId)
                            this.messageToast = this.$t(fields)
                        } else {
                            this.messageToast = this.$t(res.data.messageId)
                            this.messageIdToast = res.data.messageId
                        }
                        $('#toast').modal('show')
                    }
                },
            )

            // Request.do(
            //     this,
            //     'PUT',
            //     Request.getDefaultHeader(this),
            //     this.data,
            //     `${Endpoints.companies.company}${state.lastDocument}`,
            //     companyResponse => {
            //         //SUCCESS CALLBACK
            //         $('#spinner').modal('toggle')
            //         this.$eventHub.$emit('refreshList')
            //         this.flashMessage.info(this.configMessage(this.$t('string.msg.company.register.title.alter'), this.$t('string.msg.company.register.message.alter'), 'top left', 3000), {
            //             mounted: this.showText(this.$t('string.msg.company.register.message.alter')),
            //             destroyed: this.clearText(),
            //         })
            //     },
            //     error => {
            //         //ERROR CALLBACK
            //         $('#spinner').modal('toggle')
            //         let res = error.response
            //         if (res && res.status) {
            //             this.titleToast = this.$t('string.msg.warning')
            //             if (res.data.messageId === 'response.msg.error.empty.fields') {
            //                 let fields = ''
            //                 res.data.errors.forEach(function (value) {
            //                     fields += state.$t(value.id) + ';<br/>'
            //                 })
            //                 this.titleToast = this.$t(res.data.messageId)
            //                 this.messageToast = this.$t(fields)
            //             } else if (res.data.messageId === 'response.already.exists') {
            //                 this.messageToast = this.$t('response.company.already.exists')
            //             } else {
            //                 this.messageToast = this.$t(res.data.messageId)
            //                 this.messageIdToast = res.data.messageId
            //             }

            //             $('#toast').modal('show')
            //         }
            
            //     },
            // )
        },
        handleFileUpload() {

            this.file = this.$refs.file.files[0]
            const reader = new FileReader();

            if (this.file.size > 100000) {
                alert('Informe uma imagem menor que 100MB');
            }

            reader.onload = (e) => {

                const img = new Image();
                img.onload = () => {
                    const width = img.naturalWidth;
                    const height = img.naturalHeight;

                    if (width > 40 || height > 40) {
                        alert('Informe images com dimensões de 40px de altura e largura');
                        this.file = null;
                        img.src = null;
                    } else {
                        this.data.logoURL = e.target.result;
                    }

                };

                img.src = e.target.result;

            };

            reader.readAsDataURL(this.file);

        },
        onChangeStatus() {
            if (this.data.status !== '-1') {
                if (!confirm('Deseja alterar o status desse associado')) {
                    this.data.status = this.data.oldStatus
                    return false
                }
            }

            this.data.oldStatus = this.data.status
        },
        loadTypeServices: function (payload) {
            let query = {
                type: type,
            }
            setTimeout(async function () {
                let responseCertifies = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.parts.certifies.list}`)).data
                payload.certifies = responseCertifies.results
                let responseServices = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), { type: 'SERVICE' }, `${Endpoints.parts.families.listByType}`)).data
                payload.services = responseServices.results
            }, 100)
        },
        archive: function (response) {
            if (response == 1) {
                $('#spinner').modal('toggle')
                this.errors = []
                this.messageIdToast = null
                let state = this
                this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
                Request.do(
                    this,
                    'DELETE',
                    Request.getDefaultHeader(this),
                    this.data,
                    `${Endpoints.companies.company}${this.data.document ? this.data.document : ''}`,
                    companyResponse => {
                        //SUCCESS CALLBACK
                        $('#spinner').modal('toggle')
                        this.$eventHub.$emit('refreshList')
                        this.flashMessage.warning(this.configMessage(this.$t('string.msg.company.register.title.filed'), this.$t('string.msg.company.register.message.filed'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.company.register.message.filed')),
                            destroyed: this.clearText(),
                        })
                    },
                    error => {
                        //ERROR CALLBACK
                        $('#spinner').modal('toggle')
                        let res = error.response
                        if (res && res.status) {
                            this.titleToast = this.$t('string.msg.warning')
                            if (res.data.messageId === 'response.msg.error.empty.fields') {
                                let fields = ''
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id) + ';<br/>'
                                })
                                this.titleToast = this.$t(res.data.messageId)
                                this.messageToast = this.$t(fields)
                            } else {
                                this.messageToast = this.$t(res.data.messageId)
                                this.messageIdToast = res.data.messageId
                            }

                            $('#toast').modal('show')
                        }
                        
                    },
                )
            }
        },
        confirmArchive: function (item) {
            this.titleToast = this.$t('string.msg.confirm')
            this.messageToast = this.$t('response.archive.company.confirmation')
            this.cancelText = this.$t('string.msg.cancel')
            this.yesText = this.$t('string.msg.yes')
            $('#confirmationModal').modal('show')
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this
            
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.data.address,
                `${Endpoints.addresses.geolocation}`,
                geoResponse => {
                    //SUCCESS CALLBACK
                    
                    // if (geoResponse.results.length == 0) {
                    //     return callbackError(this.$t('string.company.register.address.invalid'))
                    // } else if (geoResponse.results.length == 1) {

                    let geo = geoResponse.results[0]
                    let addressObj = instanceateAddress(state.data.address, geoResponse.results[0])

                    if (addressObj) {
                        return callbackSuccess(state.data)
                    } else {
                        // state.data.address
                        return callbackError(state.$t('string.company.register.address.invalid'))
                    }
                    // } else if (geoResponse.results.length > 1) {
                    //     state.addresses = geoResponse.results
                    //     $('#modalListAddress').modal('toggle')
                    // }
                },
                error => {
                    //ERROR CALLBACK
                    console.log(error)
                    let res = error.response
                    if (res && res.status) {
                        this.titleToast = this.$t('string.msg.warning')
                        if (res.data.messageId === 'response.msg.error.empty.fields') {
                            let fields = ''
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id) + ';<br/>'
                            })
                            this.titleToast = this.$t(res.data.messageId)
                            this.messageToast = this.$t(fields)
                        } else if (res.data.messageId === 'response.already.exists') {
                            this.messageToast = this.$t('response.user.already.exists')
                        } else {
                            this.messageToast = this.$t(res.data.messageId)
                            this.messageIdToast = res.data.messageId
                        }

                        $('#toast').modal('show')
                    }
                },
            )
        },
        getAddressData: function (geo, placeResultData) {
            let state = this
            const locale = {
                address: placeResultData.formatted_address,
                geolocation: {
                    latitude: geo.latitude,
                    longitude: geo.longitude,
                },
            }

            state.data.locale = locale
        },
        getPlaces(keyword) {
            Request.do(
                this,
                'GET',
                Request.getDefaultHeader(this),
                null,
                `${Endpoints.addresses.places.search}${keyword}`,
                response => {
                    //SUCCESS CALLBACK
                    this.places = response.results
                },
                error => {
                    //ERROR CALLBACK
                    console.log(error)
                },
            )
        },
        selectAddress: function (index) {
            let addressObj = instanceateAddress(this.data.address, this.addresses[index])

            if (addressObj) {
                addressObj.ibge = this.data.address.ibge
                addressObj.gia = this.data.address.gia
                addressObj.complement = this.data.complement
                this.data.address = addressObj
                $('#modalListAddress').modal('toggle')
                this.save(this.data)
            } else {
                this.errors = []
                this.errors.push(this.$t('string.company.register.address.invalid'))
                $('#modalListAddress').modal('toggle')
            }
        },
        loadInfosByCEP: function () {
            let state = this
            if (this.data.address && this.data.address.cep && this.data.address.cep.length == 9) {
                $('#spinner').modal('toggle')
                Request.do(
                    this,
                    'GET',
                    {},
                    {},
                    `${Endpoints.cep.find}${this.data.address.cep}/json`,
                    response => {
                        //SUCCESS CALLBACK
                        if (response) {
                            state.data.address.address = response.logradouro
                            state.data.address.neighborhood = response.bairro
                            state.data.address.city = response.localidade
                            state.data.address.state = response.uf
                            state.data.address.ibge = response.ibge
                            state.data.address.gia = response.gia
                        }

                        $('#spinner').modal('toggle')
                    },
                    error => {
                        //ERROR CALLBACK
                        $('#spinner').modal('toggle')

                    },
                )
            }
        },
        checkForm: function (e) {
            this.errors = []
            if (!this.data.fantasyName) {
                this.errors.push(this.$t('response.user.register.fantasyName.required'))
            }
            if (!this.data.socialName) {
                this.errors.push(this.$t('response.user.register.socialName.required'))
            }
            if (!this.data.document) {
                this.errors.push(this.$t('response.user.register.document.required'))
            }
            if (this.data.typeService == -1) {
                this.errors.push(this.$t('response.user.register.typeService.required'))
            }
            if (this.data.isBranch && !this.data.mainCompany) {
                this.errors.push(this.$t('response.user.register.document.maincompany'))
            }
            if(this.address) {
                if (!this.data.address.cep) {
                    this.errors.push(this.$t('response.address.register.cep.required'))
                }
                if (this.data.address.state == -1) {
                    this.errors.push(this.$t('response.address.register.city.state.required'))
                }
                if (!this.data.address.city) {
                    this.errors.push(this.$t('response.address.register.city.required'))
                }
                if (!this.data.address.neighborhood) {
                    this.errors.push(this.$t('response.address.register.neighborhood.required'))
                }
                if (!this.data.address.address) {
                    this.errors.push(this.$t('response.address.register.address.required'))
                }
                if (!this.data.address.number) {
                    this.errors.push(this.$t('response.address.register.number.required'))
                }
            }
            
            if (this.errors.length > 0) {
                e.preventDefault()
            } else {

                if(this.data._id)
                    this.save(this.data)
                else {
                    this.loadGeolocation(
                        newData => {
                            console.log('GEO', newData)
                            this.save(newData)
                        },
                        error => {
                            console.log(err)
                            this.errors.push(error)
                        },
                    )
                }
            }
        },
        selectItem: function (item) {
            
            const data = item
            data.oldStatus = item.status
            data.document = data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
            this.lastDocument = data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '')
            delete item.address;
            
            if (data.address) {
                data.address.state = data.address.state.toUpperCase()
                data.fantasyName = Common.camelize(data.fantasyName)
                data.socialName = Common.camelize(data.socialName)
                data.address.address = Common.camelize(data.address.address)
                data.address.city = Common.camelize(data.address.city)
                data.address.neighborhood = Common.camelize(data.address.neighborhood)
                if (data.address.complement) {
                    data.address.complement = Common.camelize(data.address.complement)
                }
            }

            if (!data.isGeoreferencedCompany) {
                data.isGeoreferencedCompany = false
            }

            if (!data.locale) {
                data.locale = {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                }
            }

            if (!data.fuels) {
                data.fuels = {
                    gnv: 0,
                    gas: 0,
                    premmiumGas: 0,
                    additiveGas: 0,
                    ethanol: 0,
                    premmiumEthanol: 0,
                    diesel: 0,
                    dieselS10: 0,
                    dieselS500: 0,
                    electricity: 0,
                }
            } else {
                data.fuels.gnv = Number(data.fuels.gnv).toFixed(2)
                data.fuels.gas = Number(data.fuels.gas).toFixed(2)
                data.fuels.premmiumGas = Number(data.fuels.premmiumGas).toFixed(2)
                data.fuels.additiveGas = Number(data.fuels.additiveGas).toFixed(2)
                data.fuels.ethanol = Number(data.fuels.ethanol).toFixed(2)
                data.fuels.premmiumEthanol = Number(data.fuels.premmiumEthanol).toFixed(2)
                data.fuels.diesel = Number(data.fuels.diesel).toFixed(2)
                data.fuels.dieselS10 = Number(data.fuels.dieselS10).toFixed(2)
                data.fuels.dieselS500 = Number(data.fuels.dieselS500).toFixed(2)
                data.fuels.electricity = Number(data.fuels.electricity).toFixed(2)
                
            }

            if (!data.tags) data.tags = []

            

            this.data = data
            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout(() => (this.text = ''), 500)
        },
        clearForm: function () {
            this.data = {
                auxStatus: 'ACTIVE',
                status: 'ACTIVE',
                isBranch: false,
                fantasyName: null,
                socialName: null,
                email: null,
                document: null,
                isGeoreferencedCompany: null,
                address: {
                    state: -1,
                    cep: null,
                    city: null,
                    address: null,
                    neighborhood: null,
                    number: null,
                },
                primaryPhone: null,
                secondaryPhone: null,
                talkTo: null,
                typeService: [],
                manufacturers: [],
                families: [],
                manufacturerFamilies: [],
                locale: {
                    address: null,
                    geolocation: {
                        latitude: null,
                        longitude: null,
                    },
                },
                tags: [],
                fuels: {
                    gnv: null,
                    gas: null,
                    premmiumGas: null,
                    additiveGas: null,
                    ethanol: null,
                    premmiumEthanol: null,
                    diesel: null,
                    dieselS10: null,
                    dieselS500: null,
                    electricity: null,
                },
            }
        },
        listManufacturer: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listFamilies: function (item) {
            return item.families.filter(i => i.type === 'TRUCK_TRAILER')
        },
        listManufacturerTruck: function () {
            return this.data.manufacturerFamilies.filter(i => i.type === 'TRUCK')
        },
        listFamiliesTruck: function (item) {
            return item.families.filter(i => i.type === 'TRUCK')
        },

        selectAll: function () {
            if (!this.isAllSelected) {
                let state = this
                this.data.families = []
                this.families.forEach(function (item) {
                    if (item && item._id) state.data.families.push(item._id)
                })
                this.isAllSelected = true
            } else {
                this.data.families = []
                this.isAllSelected = false
            }
        },
        configMessage: function (title, message, position, time) {
            const config = {
                title: title,
                message: message,
                position: position,
                x: window.innerWidth / 60,
                y: window.innerHeight / 1.3,
                time: time,
            }
            return config
        },
        // sendLogoFile: function () {

        //     const formData = new FormData();
        //     formData.append('file', this.file)
        //     const data = JSON.parse(JSON.stringify(this.data))

        //     Request.do(
        //         this,
        //         'POST',
        //         Request.getDefaultHeader(this),
        //         formData,
        //         `${Endpoints.companies.uploadLogo}${data._id}`,
        //         response => {

        //             this.flashMessage.info(this.configMessage(this.$t('string.msg.register.title.alter'), this.$t('string.msg.gas.station.updated.message.success'), 'top left', 3000), {
        //                 mounted: this.showText(this.$t('string.msg.gas.station.updated.message.success')),
        //                 destroyed: this.clearText(),
        //             })
        //             this.data.logoURL = response.result.logoURL
        //         },
        //         error => {
        //             //ERROR CALLBACK
        //             $('#spinner').modal('toggle')
        //             let res = error.response
        //             if (res && res.status) {
        //                 this.titleToast = this.$t('string.msg.warning')
        //                 this.messageToast = 'Erro ao processar upload'
        //                 $('#toast').modal('show')
        //             }
        //         }
        //     )
        // },
        camelize: Common.toUpperCase,
        getType: type,
    },
}
</script>
